import { render, staticRenderFns } from "./UnifiedSelect.vue?vue&type=template&id=4ae8f5fd&"
import script from "./UnifiedSelect.vue?vue&type=script&lang=js&"
export * from "./UnifiedSelect.vue?vue&type=script&lang=js&"
import style0 from "./UnifiedSelect.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports